
<template>
  <v-container>
    <v-card class="mt-8 pa-4">
      <div class="py-2 px-4 text-h5 font-weight-medium primary--text">
        {{ $langs.MyAccount.myProfile[$langs.lang] }}
      </div>

      <v-row class="mt-3">
        <!-- Left Panel -->
        <v-col class="shrink left-cols">
          <div class="text-center">
            <!-- Profile Image -->
            <div>
              <v-avatar size="100">
                <v-img :src="profileImage" class="grey"></v-img>
              </v-avatar>
            </div>

            <input
              type="file"
              accept="image/*"
              ref="file"
              hidden
              @change="onFilesSelected"
            />
            <!-- Upload Button -->
            <v-btn
              x-small
              color="primary"
              class="mt-3"
              for="file"
              @click="$refs.file.click()"
              >{{ $langs.Gen.upload[$langs.lang] }}</v-btn
            >
          </div>
        </v-col>

        <!-- Right Main Panel -->
        <v-col>
          <v-row no-gutters>
            <div class="grey--text">
              <div>{{ $langs.MyAccount.editAccountManageYourPersonalInformation[$langs.lang] }}</div>
            </div>
          </v-row>
          <v-divider class="mt-2 bold-1"></v-divider>

          <v-form ref="form" :disabled="loading">
            <v-row no-gutters class="pt-3">
              <!-- คอลัมซ้าย -->
              <v-col cols="6">
                <v-text-field
                  :label="$langs.MyAccount.firstname[$langs.lang]"
                  :rules="[
                    (v) => !!v || 'required',
                    (v) =>
                      /(^[ก-๙|a-zA-Z]*$)/.test(v) ||
                      'Name must contain only letter',
                  ]"
                  v-model="account.name.firstname"
                ></v-text-field>

                <v-text-field
                  :label="$langs.MyAccount.displayname[$langs.lang]"
                  v-model="account.name.displayname"
                ></v-text-field>

                <v-text-field
                  label="Email"
                  disabled
                  v-model="account.email"
                ></v-text-field>

                <!-- <v-text-field label="New Password"> </v-text-field>
                <v-text-field label="Current password *"> </v-text-field> -->
              </v-col>

              <!-- คอลัมขวา -->
              <v-col cols="6" class="px-3">
                <v-text-field
                  :label="$langs.MyAccount.lastname[$langs.lang]"
                  :rules="[
                    (v) => !!v || 'required',
                    (v) =>
                      /(^[ก-๙|a-zA-Z]*$)/.test(v) ||
                      'Name must contain only letter',
                  ]"
                  v-model="account.name.lastname"
                ></v-text-field>
                <!-- <v-text-field label="Date of Birth"></v-text-field> -->
                <div class="grey--text text--darken-1">
                  {{ $langs.MyAccount.gender[$langs.lang] }}
                  <v-radio-group
                    row
                    class="mt-0"
                    disabled
                    v-model="account.gender"
                    :rules="[(v) => !!v || 'required']"
                  >
                    <v-radio :label="$langs.MyAccount.male[$langs.lang]" value="m" :ripple="false"></v-radio>
                    <v-radio :label="$langs.MyAccount.female[$langs.lang]" value="w" :ripple="false"></v-radio>
                    <v-radio :label="$langs.MyAccount.other[$langs.lang]" value="o" :ripple="false"></v-radio>
                  </v-radio-group>
                </div>
              </v-col>
            </v-row>

            <v-row no-gutters class="justify-end px-3">
              <v-btn
                color="primary"
                @click="updateProfile()"
                :disabled="!change"
                :loading="loading"
                :ripple="false"
                >{{ $langs.Gen.save[$langs.lang] }}</v-btn
              >
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>
<script>
import user from "../../services/user";
import api from "../../services/api";
import { userImageUrl, compressImages } from "../../services/constants";

export default {
  data: () => ({
    profileImage: "",
    account: {
      email: "",
      name: {
        firstname: "",
        lastname: "",
        displayname: "",
      },
      gender: "",
      birthdate: "",
      newpassword: "",
      profileImage: null,
      currentpassword: "", //add new currentpassword
    },
    // original data
    temp_account: {},
    fileSize: 0,

    loading: false,
    // if data change, this will be true
    change: false,
    MAX_LOGO_SIZE: 2,
  }),
  mounted() {
    this.getProfile();
  },
  methods: {
    async onFilesSelected(event) {
      this.account.profileImage = "",
      this.profileImage = URL.createObjectURL(event.target.files[0]);
      this.change = true;
      let file = (await compressImages([...event.target.files], { quality: 'MID' }))[0];
      this.account.profileImage = file;
      this.fileSize = (file.size / 1000000).toFixed(2);
    },
    async getProfile() {
      this.change = false;
      this.loading = true;
      const account = await user.getProfile();
      if (!account.success) return;
      // Update To App Variable / UserMenu (@Nav)
      this.$store.dispatch({ type: "UpdateUserInfo", account: JSON.parse(JSON.stringify(account)) });
      this.loading = false;
      this.temp_account = JSON.parse(JSON.stringify(account.userInfo));
      this.account = account.userInfo;
      if (account.userInfo.profileImage)
        this.profileImage = `${userImageUrl(
          account.userInfo.profileImage
        )}?r=${Math.random()}`;
    },
    async updateProfile() {
      if (!this.$refs.form.validate()) return;
      if (this.fileSize > this.MAX_LOGO_SIZE)
        return api.makeAlert(
          `Profile image is too large. (more than ${MAX_LOGO_SIZE} MB)`,
          "error"
        );
      if (!this.change) return api.makeAlert("No data change", "error");

      // Remove unchange variable
      let account = JSON.parse(JSON.stringify(this.account));
      for (let key in account) {
        if (
          JSON.stringify(account[key]) == JSON.stringify(this.temp_account[key])
        ) {
          delete account[key];
        }
      }

      let { name, gender, birthdate } = account;
      let formData = new FormData();
      if (name) {
        formData.append("firstname", name.firstname);
        formData.append("lastname", name.lastname);
        if (name.displayname != null)
          formData.append("displayname", name.displayname);
      }
      if (gender) formData.append("gender", gender);
      if (birthdate) formData.append("birthdate", birthdate);
      
      // if profileImage is avaiale OR if image is compressing
      if (this.account.profileImage || this.account.profileImage == "") {
        this.loading = true;
        while (this.account.profileImage == "")
          await new Promise(r => setTimeout(r, 50));
        formData.append("profileImage", this.account.profileImage);
      }
      
      // Update
      this.loading = true;
      let { success, msg } = await user.updateProfile(formData);
      this.loading = false;
      if (!success) return api.makeAlert(`Error, ${msg}`, "error");
      api.makeAlert("Saved", "success");
      this.getProfile();
    },
  },
  watch: {
    account: {
      handler(acc) {
        this.change = JSON.stringify(acc) != JSON.stringify(this.temp_account);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.left-cols {
  flex-basis: 100%;

  @media #{map-get($display-breakpoints, 'sm-and-up' )} {
    flex-basis: 220px;
  }
}
</style>
